var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vf-badge vf-label-text",class:_vm.classes,attrs:{"aria-label":_vm.ariaLabel}},[_c('span',{attrs:{"aria-hidden":Boolean(_vm.ariaLabel).toString()}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }